import React, { useEffect } from 'react';
import { getAllForms, getFormConfig } from '../../forms';

const FormDebug = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      console.log('=== FORM DEBUG INFORMATION ===');
      
      // Check all forms
      const allForms = getAllForms();
      console.log(`Total forms in registry: ${allForms.length}`);
      
      allForms.forEach(form => {
        console.log(`Form: ${form.id} (${form.name})`);
        console.log(`  Component exists: ${!!form.component}`);
        console.log(`  Component type: ${typeof form.component}`);
      });
    }
  }, []);
  
  // Only render in development or if specifically enabled
  if (process.env.NODE_ENV !== 'development') return null;

  return (
    <div className="text-xs bg-gray-50 border border-gray-200 p-2 my-2 rounded text-gray-600 font-mono">
      <p><strong>Debug Mode:</strong> Check console for form registry details.</p>
    </div>
  );
};

export default FormDebug;